function isNumber(value: any) {
    return !isNaN(value)
}

export default isNumber